import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../assets/filter/box-open.svg'


const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 d-flex justify-content-between align-items-center p-3" }
const _hoisted_4 = { class: "d-flex flex-row gap-3" }
const _hoisted_5 = { class: "d-flex gap-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1)
const _hoisted_7 = ["onMouseover"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1.1em",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "white",
    d: "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1.1em",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "white",
    d: "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
  })
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  class: "d-flex gap-4 align-items-center",
  style: {"position":"relative"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  style: {"border-radius":"10px !important","opacity":"0.5"},
  class: "overflow-hidden"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "images/default foto2 loja.png",
    alt: "",
    style: {"width":"100px"}
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  type: "button",
  class: "fas fa-external-link-alt bg-white p-1"
}, null, -1)
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "d-flex flex-column gap-2" }
const _hoisted_19 = { class: "d-flex justify-content-between" }
const _hoisted_20 = { class: "m-0 subtitulo bold cor_texto_1" }
const _hoisted_21 = {
  style: {"height":"fit-content"},
  class: "d-flex justify-content-start gap-2"
}
const _hoisted_22 = { class: "texto cor_texto_1 me-auto" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "texto cor_texto_1" }, "Plano:", -1)
const _hoisted_24 = { class: "texto text-danger" }
const _hoisted_25 = { class: "demo-progress py-2" }
const _hoisted_26 = { class: "d-flex row py-4 align-items-center" }
const _hoisted_27 = { class: "col-4 d-flex flex-column p-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"18px"},
  class: "m-0 fas fa-pencil-alt"
}, null, -1)
const _hoisted_29 = { class: "col-4 d-flex flex-column p-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z" })
], -1)
const _hoisted_31 = { class: "col-4 d-flex flex-column p-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-sharp fa-regular fa-box-open" }, null, -1)
const _hoisted_33 = { class: "col-4 d-flex flex-column p-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-clipboard-list" }, null, -1)
const _hoisted_35 = { class: "col-4 d-flex flex-column p-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-user" }, null, -1)
const _hoisted_37 = { class: "col-4 d-flex flex-column p-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-clipboard-check" }, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "card d-flex h-100 justify-content-center",
  id: "empty"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h3", { style: {"color":"#80808F"} }, "Nenhuma loja encontrada", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  class: "m-5",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = {
  key: 1,
  class: "d-flex flex-column gap-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_EditStore = _resolveComponent("EditStore")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.exibirEditar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("section", _hoisted_3, [
              _createVNode(_component_Title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Lojas")
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_input, {
                  clearable: "",
                  placeholder: "Busque uma loja",
                  modelValue: _ctx.fastFind,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fastFind) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Button, {
                    type: "button",
                    style: {"width":"max-content"},
                    text: "Adicionar Loja",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newLojaCreate(), (_ctx.nomeLoja = '')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeArray, (loja, key) => {
              return (_openBlock(), _createElementBlock("section", {
                key: key,
                class: "col-xl-6 p-3"
              }, [
                _createElementVNode("div", {
                  style: {"border-radius":"10px","position":"relative"},
                  class: "card px-5 pt-5",
                  onMouseover: ($event: any) => (_ctx.hoveredCard = key)
                }, [
                  (_ctx.hoveredCard === key)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "disabledStore",
                        onClick: ($event: any) => (_ctx.changeFixed(loja.id))
                      }, _hoisted_10, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  (loja.fixed)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "selectedStore",
                        onClick: ($event: any) => (_ctx.changeFixed(loja.id))
                      }, _hoisted_13, 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  _createElementVNode("section", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_router_link, {
                      to: { name: 'acompanhamentoImplantacao', query: { cnpj: loja.cnpj } },
                      target: "_blank",
                      style: {"position":"absolute","top":"-10px","left":"80px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("p", _hoisted_20, _toDisplayString(loja.nome), 1),
                          _createVNode(_component_el_switch, {
                            modelValue: loja.status,
                            "onUpdate:modelValue": ($event: any) => ((loja.status) = $event),
                            size: "large",
                            class: "custom-switch",
                            onChange: ($event: any) => (_ctx.alteraStatusLoja(loja))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, _toDisplayString(loja.grupo), 1),
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, _toDisplayString(loja.plano), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_el_progress, {
                            percentage: loja.progress
                          }, null, 8, ["percentage"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("section", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_Button, {
                        type: "button",
                        variant: "primary",
                        text: "Editar",
                        onClick: ($event: any) => (_ctx.getInfoLojas(loja.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_28
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_Button, {
                        type: "button",
                        variant: "primary",
                        text: "Usuários",
                        onClick: ($event: any) => (_ctx.router.push({name: 'users', query: { idLoja: loja.id }}))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_Button, {
                        type: "button",
                        variant: "primary",
                        text: "Produtos",
                        onClick: ($event: any) => (_ctx.redirectToStore('produtos', loja.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_32
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_Button, {
                        type: "button",
                        text: "Cardápio",
                        variant: "primary",
                        onClick: ($event: any) => (_ctx.router.push({name: 'cardapio', query: { idLoja: loja.id }}))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_Button, {
                        type: "button",
                        text: "Clientes",
                        variant: "primary",
                        onClick: ($event: any) => (_ctx.redirectToStore('atendimentos',loja.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_36
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_Button, {
                        type: "button",
                        variant: "primary",
                        text: "Atendimentos",
                        onClick: ($event: any) => (_ctx.redirectToStore('atendimentos',loja.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ])
                ], 40, _hoisted_7)
              ]))
            }), 128)),
            (!_ctx.storeArray.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_42))
              : _createCommentVNode("", true),
            _createVNode(_component_Pagination, {
              ref: "filhoRef",
              arr: _ctx.storeArray,
              totalBanco: _ctx.total,
              tipo: "Lojas encontradas",
              onPageChanged: _ctx.handlePage
            }, null, 8, ["arr", "totalBanco", "onPageChanged"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createVNode(_component_EditStore, {
            onToggleScreenEdit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleScreenEdit())),
            nomeLojaDinamico: _ctx.nomeLoja,
            onUpdateGradeLojas: _ctx.atualizaGrade,
            exibirIntJet: _ctx.exibirIntegracao
          }, null, 8, ["nomeLojaDinamico", "onUpdateGradeLojas", "exibirIntJet"])
        ]))
  ]))
}